var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44219 14.2957L3.17109 16.1941C3.08914 16.262 2.98965 16.3051 2.88415 16.3187C2.77864 16.3322 2.67146 16.3156 2.57504 16.2707C2.47861 16.2258 2.39689 16.1545 2.33936 16.065C2.28183 15.9755 2.25084 15.8716 2.25 15.7652V4.59961C2.25 4.45043 2.30926 4.30735 2.41475 4.20186C2.52024 4.09637 2.66332 4.03711 2.8125 4.03711H15.1875C15.3367 4.03711 15.4798 4.09637 15.5852 4.20186C15.6907 4.30735 15.75 4.45043 15.75 4.59961V13.5996C15.75 13.7488 15.6907 13.8919 15.5852 13.9974C15.4798 14.1028 15.3367 14.1621 15.1875 14.1621H5.80078C5.66909 14.1621 5.5418 14.2096 5.44219 14.2957V14.2957Z",
    stroke: "#42296E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.94336C9.46599 9.94336 9.84375 9.5656 9.84375 9.09961C9.84375 8.63362 9.46599 8.25586 9 8.25586C8.53401 8.25586 8.15625 8.63362 8.15625 9.09961C8.15625 9.5656 8.53401 9.94336 9 9.94336Z",
    fill: "#42296E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 9.94336C6.09099 9.94336 6.46875 9.5656 6.46875 9.09961C6.46875 8.63362 6.09099 8.25586 5.625 8.25586C5.15901 8.25586 4.78125 8.63362 4.78125 9.09961C4.78125 9.5656 5.15901 9.94336 5.625 9.94336Z",
    fill: "#42296E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 9.94336C12.841 9.94336 13.2188 9.5656 13.2188 9.09961C13.2188 8.63362 12.841 8.25586 12.375 8.25586C11.909 8.25586 11.5312 8.63362 11.5312 9.09961C11.5312 9.5656 11.909 9.94336 12.375 9.94336Z",
    fill: "#42296E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackComment);
export default __webpack_public_path__ + "static/media/feedback-comment.8352013d26860d2fa354957ecc14d594.svg";
export { ForwardRef as ReactComponent };